import { LinkProps } from 'react-router';

/**
 * Whether a nav item points at the page currently open.
 *
 * Shared by `Item` (desktop bar) and `MobileItem` (drawer), which are fed the
 * same `navbarItems` array by `components/Header`. It lived twice, verbatim and
 * uncommented in one copy, until ENG-5642; one subject means the warning below
 * reaches whichever file the next person is reading.
 *
 * The prefix half is what keeps a section lit on its own detail routes, e.g.
 * Engagements on `/engagements/:id`. The cost is that it cannot tell a child
 * route from a SIBLING surface that merely lives under the same prefix: give one
 * nav item `/x` and another `/x/y` and the `/x/y` page lights up both, because
 * each item decides alone and neither can see it lost to a longer match.
 * ENG-5642 hit that with the approvals inbox at `/engagements/approvals` and
 * resolved it by moving the sibling to its own top-level path, which is why
 * there is no such pair in the nav today. An `exact` opt-out is NOT the
 * alternative — it would take the detail-route highlight away with it. Fixing it
 * properly means ranking matches across items, which a single item cannot do.
 */
export default function isNavItemActive(pathname: string, path?: LinkProps['to']): boolean {
  const pathStr = typeof path === 'string' ? path : '';
  return !!pathStr && (pathname === pathStr || pathname.startsWith(`${pathStr}/`));
}
